import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useApiClient } from "../useApiClient";
import type { components } from "../schema";

import { INSTRUMENTS_QUERY_KEY } from "./useInstruments";

type CreateInstrumentBody = components["schemas"]["CreateInstrumentBody"];
type InstrumentResponse = components["schemas"]["InstrumentResponse"];

export function useCreateInstrument() {
  const client = useApiClient();
  const queryClient = useQueryClient();
  return useMutation<InstrumentResponse, Error, CreateInstrumentBody>({
    mutationFn: async (body) => {
      const { data, error } = await client.POST("/api/instruments", { body });
      if (error !== undefined) {
        throw new Error("Failed to create instrument");
      }
      return data;
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: INSTRUMENTS_QUERY_KEY });
    },
  });
}
